import { imgPreview } from '@/utils/imageRendering';
import { Button, Box, Backdrop, CircularProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import { ImageFromFile } from './ImageFromFile';
import { ImageFromServer } from './ImageFromServer';

interface ImageCropComponentProps {
  imageId?: string;
  onImageFileChanged?: (file: File | null | undefined) => void;
  imageFile: File | null | undefined;
}

export const ImageCropComponent = ({ imageId, onImageFileChanged, imageFile }: ImageCropComponentProps) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [cropping, setCropping] = useState(false);

  useEffect(() => {
    const cropFunction = async () => {
      if (completedCrop && imgRef.current && crop) {
        const blob = await imgPreview(imgRef.current, completedCrop);
        const imageFile = new File([blob], 'image.jpeg', {
          type: blob.type,
        });
        if (onImageFileChanged) onImageFileChanged(imageFile);
        setCropping(false);
        setCrop(undefined);
      } else {
        setCropping(false);
      }
    };
    cropFunction();
  }, [cropping]);

  return (
    <>
      {imageFile ? (
        <>
          <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={cropping}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ReactCrop crop={crop} onComplete={(c) => setCompletedCrop(c)} onChange={(c) => setCrop(c)}>
              <ImageFromFile ref={imgRef} thumbnail={true} style={{ maxWidth: 150, maxHeight: 150 }} image={imageFile}></ImageFromFile>
            </ReactCrop>
            <Button sx={{ mt: 2 }} onClick={async () => setCropping(true)}>
              Crop
            </Button>
          </Box>
        </>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <ImageFromServer sx={{ maxWidth: 150, maxHeight: 150 }} thumbnail={true} alt="" id={imageId} />
        </Box>
      )}
    </>
  );
};
